import React, { useState } from "react";
import CheckoutProductsModal from "./CheckoutProductsModal";
import { ProductFull } from "../Cart/CartAction";

interface CheckoutProductListProps {
    selectedItems: ProductFull[];
}

export default function CheckoutProductList({ selectedItems }: CheckoutProductListProps) {
    const [open, setOpen] = useState(false);

    // Filter products (if you want to group by seller later, you can do it here)
    // For now, listing all items directly

    // Calculate totals for each item
    // Assuming 1 seller for now as per current UI structure or mapping all
    
    return (
        <>
            {/* ==== PHẦN DANH SÁCH RÚT GỌN ==== */}
            <section
                className="MuiPaper-root styles_root__o8ek_ MuiPaper-elevation0 MuiPaper-rounded"
                id="checkout-product-list"
            >
                <div className="MuiBox-root css-1qm1lh">
                    <h2 className="styles_title__Y0M1E">
                        Danh sách sản phẩm (Số lượng: {selectedItems.length})
                    </h2>
                </div>

                <div className="MuiTableContainer-root">
                    <table className="MuiTable-root styles_cartItemsTable__HT5Rb">
                        <tbody className="MuiTableBody-root">

                            {/* Seller header - Just keeping static for now or can deduce from items if seller info exists */}
                            {selectedItems.length > 0 && (
                            <tr className="MuiTableRow-root styles_noBorder__bNo5B">
                                <td
                                    className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall"
                                    colSpan={100}
                                >
                                    <div className="MuiBox-root css-j0ozid">
                                        <div className="styles_sellerName__PC1wP MuiBox-root css-i9gxme">
                                           Sản phẩm đã chọn
                                        </div>

                                        <div className="styles_header__UfJLh MuiBox-root css-epvm6">
                                            {selectedItems.length} sản phẩm
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            )}

                            {/* table header */}
                            <tr className="MuiTableRow-root styles_dashBorder__uLpxz">
                                <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-sizeSmall" width="50%">
                                    Sản phẩm
                                </td>
                                <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignCenter MuiTableCell-sizeSmall">
                                    SL đặt
                                </td>
                                <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignRight MuiTableCell-sizeSmall">
                                    Giá mua (đ)
                                </td>
                                <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignRight MuiTableCell-sizeSmall">
                                    Tổng cộng (đ)
                                </td>
                            </tr>

                            {/* Map products */}
                            {selectedItems.map((item) => (
                                <tr key={item.id} className="MuiTableRow-root styles_lastBorder__U_ghb">
                                    <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                        <div className="MuiBox-root css-j0ozid">
                                            <div className="styles_productImage__7FaA6">
                                                <span style={{ position: "relative", display: "inline-block" }}>
                                                    <span>
                                                        <img
                                                            alt=""
                                                            aria-hidden="true"
                                                            src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'/%3e"
                                                        />
                                                    </span>

                                                    <img
                                                        alt={item.name}
                                                        src={item.image}
                                                        style={{
                                                            position: "absolute",
                                                            inset: 0,
                                                            margin: "auto",
                                                            objectFit: "contain",
                                                            minWidth: "100%",
                                                            minHeight: "100%"
                                                        }}
                                                    />
                                                </span>
                                            </div>

                                            <div className="styles_productName__FVRI6">
                                                {item.name}
                                            </div>
                                        </div>
                                    </td>

                                    <td className="MuiTableCell-root MuiTableCell-body styles_header__UfJLh MuiTableCell-alignCenter MuiTableCell-sizeSmall">
                                        {item.qty}
                                    </td>

                                    <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                        <div className="styles_flex_no_wrap__1vvft styles_justifyContentEnd__yd1n7 MuiBox-root css-0">
                                            <div className="styles_canvasPrice__vw932 MuiTableCell-alignRight text-[#005c29] text-[16px]" style={{ height: 25 }}>
                                                 {item.rawPrice.toLocaleString('vi-VN')}đ
                                            </div>
                                        </div>
                                    </td>

                                    <td className="MuiTableCell-root MuiTableCell-body MuiTableCell-sizeSmall">
                                        <div className="styles_flex_no_wrap__1vvft styles_justifyContentEnd__yd1n7 MuiBox-root css-0">
                                            <div className="styles_canvasPrice__vw932 text-[#005c29] text-[16px]" style={{ height: 25 }}>
                                                {(item.rawPrice * item.qty).toLocaleString('vi-VN')}đ
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* BUTTON XEM TẤT CẢ */}
                {selectedItems.length > 5 && (
                    <div
                        className="styles_seeAll__ilpDo MuiBox-root css-qq9c22"
                        tabIndex={0}
                        onClick={() => setOpen(true)}
                    >
                        Xem tất cả
                    </div>
                )}
            </section>

            {/* ==== POPUP DANH SÁCH ĐẦY ĐỦ ==== */}
            {open && (
                <CheckoutProductsModal
                    open={open}
                    onClose={() => setOpen(false)}
                />
            )}
        </>
    );
}
